export function setActiveMenuItemByName(name, items) {
  if (!Array.isArray(items) || items.length < 1) {
    return false;
  }

  let hasActiveItem = false;
  for (const item of items) {
    if (Array.isArray(item)) {
      hasActiveItem = setActiveMenuItemByName(name, item) || hasActiveItem;
      continue;
    }
    if (!item || typeof item !== "object") {
      continue;
    }
    let itemActive = item.name == name;
    if (Array.isArray(item.items) && item.items.length > 0) {
      itemActive = setActiveMenuItemByName(name, item.items) || itemActive;
    }
    item.active = itemActive;
    hasActiveItem = hasActiveItem || itemActive;
  }
  return hasActiveItem;
}
